import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IonLoading, IonRefresher, IonRefresherContent } from '@ionic/react';
import { PageLayout } from 'containers/layout';
import { AuthSelectors } from 'redux/AuthRedux';
import PromotionList from 'containers/promotions/PromotionList';
import { useParams } from 'react-router';
import PromotionActions, { PromotionSelectors } from 'redux/PromotionRedux';
import api_v2 from 'services/api_v2';

function VenuePromotionsPage() {
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const params = useParams();
  const loading = useSelector(PromotionSelectors.selectPromotionsLoading);
  const promotions = useSelector(
    PromotionSelectors.selectPromotionsByVenue(params.venueId)
  );

  const handleLoadPromotions = async (e) => {
    try {
      const api = api_v2(token);
      const resp = await api.getPromotions({});
      if (resp) {
        dispatch(PromotionActions.setPromotions(resp));
      }

    } catch (err) {
      console.log('load promotion error: ', err.message);
    }

    e.detail.complete();
  };

  return (
    <PageLayout title="Promotions" back="/promotions">
      <IonLoading isOpen={loading} message="Loading..." />
      <IonRefresher slot="fixed" onIonRefresh={handleLoadPromotions}>
        <IonRefresherContent />
      </IonRefresher>
      <PromotionList promotions={promotions} />
    </PageLayout>
  );
}

export default VenuePromotionsPage;
